import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import moment from 'moment-timezone';
import { RenderDatePicker, RenderCheckboxRadioField, RenderHiddenField, RenderSubmitButton } from '../common/form';
import * as Validations from '../common/form/commonValidations';

// Default Copy
const DEFAULT_COPY = {
  hed: 'When\'s your big day?',
  cta: 'Finish'
};

let Step2 = (props) => {
  const { handleSubmit, skipDate, date, overrideCopy, skipSlugStep } = props;
  const stepCopy = { ...DEFAULT_COPY, ...overrideCopy };

  return (
    <div className="row" id="step-2">
      <div className="col-xs-12 col-sm-7 step-form text-center">
        <h3 className="onboard-step-header">
          {stepCopy.hed}
          {stepCopy.dek && <p>{stepCopy.dek}</p>}
        </h3>
        <form onSubmit={handleSubmit}>
          <p className="hidden visible-xs padding-top">
            {"Don't worry, you can change this later."}
          </p>
          {/* currently using css to render separate pickers for mobile/desktop, maybe a better way to do this */}
          <div className="hidden-xs">
            <Field
              name="wedding_date"
              type="date"
              component={RenderDatePicker}
              placeholder="MM/DD/YYYY"
              className="hidden-xs"
              datePickerOptions={{
                disabledDays: {
                  before: moment(moment.utc().format('MM/DD/YYYY'), 'MM/DD/YYYY', true).toDate(),
                  after: moment(moment.utc().add(5, 'years').format('MM/DD/YYYY'), 'MM/DD/YYYY', true).toDate()
                },
                initialMonth: moment(moment.utc().add(8, 'months').format('MM/DD/YYYY'), 'MM/DD/YYYY', true).toDate()
              }}
              disabled={skipDate}
              validate={skipDate ? [Validations.DATE, Validations.DATE_WITHIN_VALID_RANGE] : [Validations.REQUIRED, Validations.DATE, Validations.DATE_WITHIN_VALID_RANGE]}
            />
          </div>
          <div className={`${skipDate ? 'disabled-mobile-picker' : ''} ${'mobile-picker hidden visible-xs'}`}>
            <Field
              name="wedding_date"
              type="date"
              id="weddingDate"
              component={RenderDatePicker}
              placeholder="MM/DD/YYYY"
              className="hidden visible-xs"
              datePickerOptions={{
                disabledDays: {
                  before: moment(moment.utc().format('MM/DD/YYYY'), 'MM/DD/YYYY', true).toDate(),
                  after: moment(moment.utc().add(5, 'years').format('MM/DD/YYYY'), 'MM/DD/YYYY', true).toDate()
                },
                inline: true,
                initialMonth: moment(moment.utc().add(8, 'months').format('MM/DD/YYYY'), 'MM/DD/YYYY', true).toDate()
              }}
              disabled={skipDate}
              validate={skipDate ? [Validations.DATE, Validations.DATE_WITHIN_VALID_RANGE] : [Validations.REQUIRED, Validations.DATE, Validations.DATE_WITHIN_VALID_RANGE]}
            />
          </div>
          <Field
            name="timezone"
            id="onboarding-timezone"
            component={RenderHiddenField}
            disabled={skipDate}
          />
          <Field
            name="skipDate"
            id="skipDate"
            component={RenderCheckboxRadioField}
            type="checkbox"
            styleOverride
            label="We haven't decided yet."
          />
          {
            skipSlugStep ?
              <div className="col-xs-12 next-button">
                <button type="submit" className="btn btn-wide btn-primary">{stepCopy.cta}</button>
              </div> :
              <div className="col-xs-12 next-button">
                <RenderSubmitButton valid={skipDate || !!date} className={'btn btn-primary btn-wide'} value={stepCopy.cta} />
              </div>
          }
          <div className="text-muted hidden-xs">
            {"Don't worry, you can change this later."}
          </div>
        </form>
      </div>
      <div className="col-xs-12 col-sm-3 hidden-xs">
        <img src="/images/doodles/onboarding_3.png" srcSet="/images/doodles/onboarding_3@2x.png 2x" alt="Zola Cake" />
      </div>
    </div>
  );
};

Step2.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  skipDate: PropTypes.bool,
  date: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})]),
  skipSlugStep: PropTypes.bool,
  overrideCopy: PropTypes.shape({
    hed: PropTypes.string,
    dek: PropTypes.string,
    cta: PropTypes.string
  })
};

const mapStateToProps = (state) => {
  const selector = formValueSelector('onboardForm');

  return {
    initialValues: {
      ...state.form.onboardForm.values,
      wedding_date: selector(state, 'skipDate') ? '' : selector(state, 'wedding_date'),
      timezone: selector(state, 'skipDate') ? '' : moment.tz.guess(),
      business_unit_feature: state.Onboard.primaryProduct
    },
    skipDate: selector(state, 'skipDate') === true,
    date: selector(state, 'wedding_date')
  };
};

Step2 = reduxForm({
  form: 'onboardForm',
  destroyOnUnmount: false,
  enableReinitialize: true
})(Step2);

export default connect(mapStateToProps)(Step2);



/** WEBPACK FOOTER **
 ** ./src/components/onboard/Step2.jsx
 **/